import { createAction, props } from '@ngrx/store';
import { StateValueHistory, SubscriptionOptions } from '../../shared/models';

export const createState = createAction('[State] Create State', props<{ key: string; fullKey: string; options?: SubscriptionOptions }>());
export const updateStates = createAction('[State] Update States', props<{ key: string; fullKey: string; date: Date }>());
export const createStateSuccess = createAction('[State] Create State Success', props<{ key: string; historyItems: StateValueHistory[] }>());
export const updateStatesSuccess = createAction(
  '[State] Update States Success',
  props<{ key: string; historyItems: StateValueHistory[] }>()
);
export const loadStateFailure = createAction('[State] Load State Failure', props<{ key: string; error: any }>());
